import React from "react";
import Cell from "../Cell";
import { OptionImage } from "../../../product/style";
import ModuleColorsDialog from "../ModuleColorsDialog";
import SectionColorsDialog from "../SectionColorsDialog";
import ColorOverrides from "../ColorOverrides";
import { isMobileOnly } from "react-device-detect";

const ColorCell = ({
  type,
  rowId,
  tempId,
  sectionId,
  isFillerRow = false,
  errorMessage,
  tableManager,
  propertyList,
  colorIdentifiers,
  isActive,
  dialogProps = {},
  pasteOverrides,
  onContextMenu,
  setCurrentTab,
  viewMode,
}) => {
  const getColorOverrides = () => {
    const colorOverrides = [];

    // Get regular color identifiers
    colorIdentifiers.forEach((identifier) => {
      const property = propertyList?.find((e) => e.identifier === identifier);
      let selectedOption;

      if (pasteOverrides) {
        const overrideValues = [
          pasteOverrides.shutter_color,
          pasteOverrides.color,
          pasteOverrides.internal_color,
        ].filter(Boolean);

        if (overrideValues.length > 0) {
          selectedOption = property?.options?.find((e) =>
            overrideValues.some((val) => val === e.identifier || val === e.name)
          );
        }
      } else {
        selectedOption = property?.options?.find((e) => e.selected);
      }

      if (!property || !selectedOption) return;

      if (type === "module" && !property.is_overridden_v2) return;

      colorOverrides.push({
        propertyName: property.name,
        selectedOption: selectedOption,
      });
    });

    // Render shutter-level color properties (S1, S2) if overridden
    if (type === "module" && propertyList) {
      const shutterLevelColorProperties = propertyList.filter(
        (property) => property.is_shutter_level_color_property === true
      );

      shutterLevelColorProperties.forEach((property) => {
        const isOverridden =
          property.is_overridden_v2 || property.is_shutter_override;

        if (!isOverridden) return;

        const selectedOption = property.options?.find(
          (option) => option.selected
        );

        if (!selectedOption) return;

        // Format property name as "Shutter S1", "Shutter S2", etc.
        const propertyName = `Shutter ${property.name}`;

        colorOverrides.push({
          propertyName: propertyName,
          selectedOption: selectedOption,
        });
      });
    }

    return colorOverrides;
  };

  const renderColorOptions = () => {
    const colorOptions = [];
    const colorOverrides = getColorOverrides();

    // Render regular color identifiers
    colorOverrides.forEach((colorOverride, index) => {
      if (!colorOverride.selectedOption?.image) return;

      colorOptions.push(
        <OptionImage
          key={`${colorOverride.propertyName}-${index}`}
          className="mt-0 rounded-circle"
          height={24}
          width={24}
          src={colorOverride.selectedOption.image}
          style={colorOptions.length > 0 ? { marginLeft: "-8px" } : {}}
        />
      );
    });

    return colorOptions;
  };

  return (
    <>
      {viewMode === "review" ? (
        <>
          {["shutter", "internal"].map((e) => {
            const property = propertyList.find(
              (prop) => prop.uniq_id === `${e}_color`
            );
            const column = `review_${e}_color`;

            const selectedOption =
              property && property.options.find((opt) => opt.selected);

            return (
              <Cell
                key={column}
                rowId={rowId}
                sectionId={sectionId}
                rowType={type}
                column={column}
                className="flex-grow-0 flex-shrink-0 justify-content-center"
                customStyles={{ width: isMobileOnly ? "15%" : "80px" }}
                tableManager={tableManager}
              >
                {selectedOption?.image && (
                  <OptionImage
                    style={{
                      outline: "1px solid rgba(0, 0, 0, 0.15)",
                    }}
                    className="m-0 rounded-circle"
                    height={24}
                    width={24}
                    src={selectedOption.image}
                  />
                )}
              </Cell>
            );
          })}
        </>
      ) : (
        (() => {
          const colorOverrides = getColorOverrides();
          return (
            <Cell
              rowType={type}
              rowId={rowId}
              column="color"
              status="focus"
              customStyles={{
                width: isMobileOnly ? "15%" : "90px",
                justifyContent: "center",
              }}
              tableManager={tableManager}
              isTemp={tempId}
              errorMessage={errorMessage}
              isFillerRow={isFillerRow}
              sectionId={sectionId}
              onContextMenu={onContextMenu}
              hoverComponent={
                !isActive && !tempId && colorOverrides.length > 0 ? (
                  <ColorOverrides colorOverrides={colorOverrides} />
                ) : null
              }
            >
              <div className="d-flex justify-content-center align-items-center position-relative">
                {!tempId && renderColorOptions()}
              </div>

              {isActive &&
                (type === "module" ? (
                  <ModuleColorsDialog
                    orderItem={dialogProps.orderItem}
                    access={dialogProps.access}
                    tableManager={tableManager}
                    moduleColorIdentifiers={colorIdentifiers}
                    updateModuleProperties={dialogProps.updateModuleProperties}
                    toggleClearOverrideModal={
                      dialogProps.toggleClearOverrideModal
                    }
                    setClearOverrideFunc={dialogProps.setClearOverrideFunc}
                    clearModuleOverrides={dialogProps.clearModuleOverrides}
                    mutateCurrentRoom={dialogProps.mutateCurrentRoom}
                    isAdmin={dialogProps.isAdmin}
                    setCurrentTab={setCurrentTab}
                  />
                ) : (
                  <SectionColorsDialog
                    group={dialogProps.group}
                    tableManager={tableManager}
                    colorIdentifiers={colorIdentifiers}
                    updateSectionProperties={
                      dialogProps.updateSectionProperties
                    }
                    mutateCurrentRoom={dialogProps.mutateCurrentRoom}
                    isAdmin={dialogProps.isAdmin}
                    setCurrentTab={setCurrentTab}
                  />
                ))}
            </Cell>
          );
        })()
      )}
    </>
  );
};

export default ColorCell;
